import React from 'react';

function SunMark() {
  return (
    <svg
      className="michaela-sun-mark"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round">
        <circle cx="7" cy="7" r="2.6" />
        <circle cx="7" cy="7" r="0.7" fill="currentColor" stroke="none" />
        <path d="M7 1.2v1.4M7 11.4v1.4M1.2 7h1.4M11.4 7h1.4M2.8 2.8l1 1M10.2 10.2l1 1M10.2 2.8l-1 1M2.8 10.2l-1 1" />
      </g>
    </svg>
  );
}

export default SunMark;
